<template>
  <div>
    <div class="games">
          <Game v-for="(item, name) in games" :key="name" v-show="currentCategory == 'all' || ((currentProvider == item.provider || currentProvider == 'all'))">
            <template slot="title">{{ item.title }}</template>
            <template slot="provider">{{ item.provider }}</template>
            <template slot="img"><img :src="item.image_full_path.replace('{domain}', current_domain).replace('https://static.egamings.com/games/', cdn_url + 'providers/')"/></template>
            <template slot="play">
              <button type="button" @click="runGame({id: item.id, device: isMobile})" class="button primary">Hemen Oyna</button>
            </template>
          </Game>
    </div>
  </div>
</template>

<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import { mapActions } from 'vuex'
  import Game from './Game'
  export default{
    data(){
      return{

      }
    },
    components:{
      Game
    },
    computed:{
      cdn_url(){
       return this.$store.getters['getCdnUrl']
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      searchValue(){
        return this.$store.getters['virtual/getSearch'];
      },
      games(){
        if(this.searchValue){
          return this.$store.getters['virtual/getGames'].filter(item => item.title.toLowerCase().includes(this.searchValue.toLowerCase()))
        }else{
          if(this.currentProvider == 'all'){
            return this.$store.getters['virtual/getGames'];
          }else{
            return _.filter(this.$store.getters['virtual/getGames'], ['provider', this.currentProvider]);
          }
        }
      },
      currentCategory(){
        return this.$store.getters['virtual/getCurrentCategory'];
      },
      currentProvider(){
        return this.$store.getters['virtual/getCurrentProvider'];
      },
    },
    methods:{
      runGame(payload){
        if(!this.$auth()){
          this.$emit('loginModal', true);
          return false;
        }else{
          this.$store.dispatch('virtual/runGame', payload)
        }
      }
    },
  }
</script>